<template>
  <div class="integralDetail ">
    <headd></headd>
    <div class="content container">
      <div class="headr">
        <div class="count"><span>我的余额(元)</span>{{ balance }}</div>
        <div class="tex" @click="gorecharge">
          <img class="icon" src="../../../../static/user/icon_17_2.png" />
          充值
        </div>
      </div>
    </div>

    <div class="listBox container">
      <div class="listOne" v-for="item in cashdetail" :key="item.id">
        <div class="type">{{ item.cashTitle }}</div>
        <div class="time">{{ item.createdAt }}</div>
        <div class="amount">￥{{ item.cashNum }}</div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getcashDetail } from "../../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      pageindex: 1,
      cashdetail: [],
      flag: false,
      balance: 0
    };
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getcashlist();
  },
  methods: {
    gorecharge() {
      this.$router.push({
        path: "addrecharge"
      });
    },
    async getcashlist() {
      var _slef = this;
      var parm = {
        uid: localStorage.getItem("userId"),
        page: _slef.pageindex,
        limit: 20
      };
      console.log(parm);
      const res = await getcashDetail(parm);
      console.log(res);
      _slef.balance = res.data.data.balance;
      _slef.cashdetail = _slef.cashdetail.concat(res.data.data.cashdetail);

      if (res.data.data.cashdetail.length < 20) {
        _slef.flag = true;
      }
    }
  },
  //   onShow() {
  //     this.cashdetail = [];
  //     this.pageindex = 1;
  //     (this.flag = false), this.getcashDetail();
  //   },
  onReachBottom() {
    if (!this.flag) {
      this.pageindex++;
      this.getcashDetail();
    }
  }
};
</script>

<style lang="less" scoped>
.integralDetail {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  @media (max-width: 991px) {
    width: 6.86rem;
  }

  .content {
    width: 8rem;
    @media (max-width: 991px) {
      width: 100%;
    }
    position: relative;
    height: 1.4rem;
    margin: 0.18rem auto 0rem auto;
    background: url(../../../../static/user/icon_16.png) no-repeat;
    background-size: contain;
    color: #ffffff;
    .headr {
      padding: 0.32rem 0.5rem;
      margin: auto;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      display: flex;
      @media (max-width: 991px) {
        padding: 0.2rem 0.5rem;
      }

      .count {
        text-align: center;
        font-size: 0.26rem;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        display: flex;
        @media (max-width: 991px) {
          font-size: 0.3rem;
        }
      }

      .tex {
        cursor: pointer;
        width: 1.2rem;
        height: 0.4rem;
        background: url(../../../../static/user/icon_17_1.png) no-repeat;
        background-size: cover;
        font-size: 0.2rem;
        align-items: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.7);
        display: flex;
        @media (max-width: 991px) {
          font-size: 0.26rem;
        }
        .icon {
          width: 0.23rem;
          height: 0.22rem;
          margin-right: 0.05rem;
        }
      }
    }
  }

  .listBox {
    flex-direction: column;
    width: 8rem;
    @media (max-width: 991px) {
      width: 100%;
    }
    .listOne {
      display: flex;
      width: ~"calc(100%)";
      flex-direction: column;
      padding: 0.34rem 0 0;
      position: relative;
      text-align: left;

      .type {
        font-size: 0.18rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }

      .time {
        opacity: 0.6;
        font-size: 0.14rem;
        padding-bottom: 0.2rem;
        padding-top: 0.2rem;
        border-bottom: 0.01rem rgba(196, 196, 204, 1) solid;
        @media (max-width: 991px) {
          font-size: 0.24rem;
        }
      }

      .amount {
        position: absolute;
        top: 0.58rem;
        right: 0.3rem;
        font-size: 0.18rem;
        color: rgba(255, 84, 90, 1);
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }
  }

  .rule {
    font-size: 0.3rem;
    color: #cd8f62;
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/recharge/recharge_list.vue